export enum SelectFieldType {
  divider,
  header,
  default,
}

type Divider = {
  type: SelectFieldType.divider;
};
type Header = {
  type: SelectFieldType.header;
  header: string;
};
type Item = {
  type: SelectFieldType.default;
  title: string;
  value: unknown | undefined;
};
export type SelectFieldDefaultItem = {
  title: string;
  value: unknown | undefined;
};
export type SelectFieldItem = Item | Divider | Header;
